document.addEventListener('DOMContentLoaded', function() {
  // --- CONFIGURATION ---
  // Standard selectors for Shopify theme sliders
  const listContainerSelector = '.product__media-list, .product-media-list, .swiper-wrapper, .slick-track';
  const mediaItemSelector = '.product__media-item, .product-media-item, .swiper-slide, .slick-slide'; 
  const imageSelector = 'img';
  
  // State tracking to prevent unnecessary layout thrashing
  let lastSelectedValue = "";

  // --- 1. THE WATCHER ---
  // Checks constantly for a change in selection
  function checkSelection() {
    const allCheckedInputs = document.querySelectorAll('input[type="radio"]:checked');
    let selectedValue = null;

    // Look for radio buttons belonging to variant options
    allCheckedInputs.forEach(input => {
      const name = input.getAttribute('name');
      // Check for standard Shopify option names
      if (name && (name === 'Material' || name === 'Color' || name.includes('Option'))) {
         selectedValue = input.value;
      }
    });

    // Fallback check for dropdown select menus
    if (!selectedValue) {
      const selects = document.querySelectorAll('select');
      selects.forEach(select => {
         if (select.value && select.name.includes('Option')) {
            selectedValue = select.value;
         }
      });
    }

    // If selection has changed, trigger the sort-and-filter routine
    if (selectedValue && selectedValue !== lastSelectedValue) {
      lastSelectedValue = selectedValue;
      sortAndFilterSlides(selectedValue);
    }
  }

  // --- 2. THE SORTER & FILTERER ---
  function sortAndFilterSlides(selection) {
    if (!selection) return;
    
    const container = document.querySelector(listContainerSelector);
    if (!container) return; // Exit if gallery isn't found

    // Prepare the strict match string
    const strictMatchValue = selection.trim().toLowerCase();
    
    // Get all currently existing slides
    const slides = Array.from(container.querySelectorAll(mediaItemSelector));
    
    // Buckets for sorting
    const matchedSlides = [];
    const genericSlides = [];

    // STEP A: Classify & set visibility
    slides.forEach(slide => {
      const img = slide.querySelector(imageSelector);
      // Treat slides without images as mismatches to be safe
      if (!img) {
         slide.style.display = 'none';
         return;
      }

      const altText = (img.getAttribute('alt') || "").trim().toLowerCase();

      // 1. Identify Generic Images
      const isGeneral = altText === "" || 
                        altText === "main" || 
                        altText.includes("{{ product.title | downcase }}");

      // 2. Identify Strict Matches (Exact naming required)
      const isStrictMatch = (altText === strictMatchValue);

      if (isStrictMatch) {
        slide.style.display = 'block';
        matchedSlides.push(slide); // Add to "Hero" bucket
      } else if (isGeneral) {
        slide.style.display = 'block';
        genericSlides.push(slide); // Add to "Generic" bucket
      } else {
        slide.style.display = 'none'; // Hide mismatches
      }
    });

    // STEP B: Physically re-order the DOM elements
    // 1. Move all generic slides to the end of the container.
    //    This preserves their relative order.
    genericSlides.forEach(slide => {
      container.appendChild(slide);
    });

    // 2. Move all matched "Hero" slides to the very beginning.
    //    We insert them before the first child of the container.
    //    We iterate in reverse to maintain their original relative order at the top.
    for (let i = matchedSlides.length - 1; i >= 0; i--) {
      container.insertBefore(matchedSlides[i], container.firstChild);
    }

    // STEP C: Trigger layout refresh for the slider script
    window.dispatchEvent(new Event('resize'));
    
    // Attempt to reset slider position to the start
    if (container.parentElement && container.parentElement.scrollTo) {
      container.parentElement.scrollTo({ left: 0, behavior: 'auto' });
    }
  }

  // Start the loop
  setInterval(checkSelection, 500);
});